module.exports = __webpack_public_path__ + "media/hyper/fonts/Nunito-Bold-a229907112951d36fed2862b38db0e46.woff";